export const rtpData = {
  default: 3,
  medium: 3.5,
  small: 2.5,
};
